"use client";

import * as React from "react";
import {
  Grid,
  Card,
  CardContent,
  Box,
  Typography,
  Button,
  Stack,
  Tabs,
  Tab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import ProductImg from "./ProductImg";
import Color from "./Color";
import Layout from "../../../../pages/operator/Layout";
import { Avatar } from "@mui/material";
import ScriptTemplateViewer from "../../../../shared/script-templates/ScriptTemplateViewer";
import { Link, useLocation, useParams, useSearchParams } from "react-router-dom";
import useFetchWithAuth from "../../../../features/hooks/useFetchWithAuth";
import { useState } from "react";
import { useEffect } from "react";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import fetchWithAuth from "../../../../util/fetchWithAuth";
import { API_URL } from "../../../../util/url";
const ProductDetailsContent = () => {
  const { productId } = useParams();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const queryCrmId = Number(searchParams.get("crm"));
  const queryProductId = searchParams.get("product_id");
  const { data, loading: productLoading, error: productError } =
    useFetchWithAuth(`/scripts/products/${productId}/`);
  const { data: crms } = useFetchWithAuth("/user/me/crms");

  const [productData, setProductData] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);
  const [crmProductLoading, setCrmProductLoading] = useState(false);
  const [crmProductError, setCrmProductError] = useState(null);
  const [crmProductsMap, setCrmProductsMap] = useState({});
  const [resolvedVersion, setResolvedVersion] = useState(null);
  const [resolvedCrossProducts, setResolvedCrossProducts] = useState([]);
  const [crossMeta, setCrossMeta] = useState({});
  const [resolveLoading, setResolveLoading] = useState(false);
  const [expanded, setExpanded] = useState(null);
  const [scriptTab, setScriptTab] = useState(0);
  const [selectedCrossProduct, setSelectedCrossProduct] = useState(null);
  const handleChange = (panel) => (_, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const handleScriptTabChange = (_, nextTab) => {
    setScriptTab(nextTab);
  };
  const formatPrice = (value) => {
    if (value == null || value === "") return "";
    const numberValue = Number(value);
    if (!Number.isFinite(numberValue)) return String(value);
    const decimals = numberValue % 1 === 0 ? 0 : 2;
    return numberValue.toLocaleString("uk-UA", {
      minimumFractionDigits: decimals,
      maximumFractionDigits: 2,
    });
  };
  const handleCrossOpen = (product) => {
    setSelectedCrossProduct(product);
  };
  const handleCrossClose = () => {
    setSelectedCrossProduct(null);
  };
  const normalizeCrossProducts = (items) =>
    Array.isArray(items)
      ? items.map((item) => {
          if (typeof item === "string" || typeof item === "number") {
            return { product_id: item };
          }
          return item;
        })
      : [];
  const normalizeCrossMeta = (items) => {
    if (!Array.isArray(items)) return {};
    return items.reduce((acc, item) => {
      const key = item?.product_id ?? item?.id ?? null;
      if (key == null) return acc;
      acc[String(key)] = item?.short_description ?? "";
      return acc;
    }, {});
  };
  const mergeCrossProducts = (sources) => {
    const result = [];
    const seen = new Set();
    sources.forEach((list) => {
      (list || []).forEach((item) => {
        if (!item) return;
        const key =
          item.cross_id ?? item.id ?? item.product_id ?? item.title ?? null;
        if (key == null) {
          result.push(item);
          return;
        }
        const keyValue = String(key);
        if (seen.has(keyValue)) return;
        seen.add(keyValue);
        result.push(item);
      });
    });
    return result;
  };
  useEffect(() => {
    setProductData(data || null);
  }, [data]);
  const storedCrmId = Number(localStorage.getItem("activeCrmId"));
  const crmId = Number.isFinite(queryCrmId)
    ? queryCrmId
    : Number.isFinite(storedCrmId)
    ? storedCrmId
    : crms?.[0]?.id;
  const resolvedProductId = queryProductId || productId;

  const isManagement = location.pathname.startsWith("/management");
  const isEditorAllowed =
    location.pathname.startsWith("/supervisor") || isManagement;
  const editorCrmId = productData?.crm ?? data?.crm ?? crmId;
  const editorProductId = productData?.product_id ?? data?.product_id ?? productId;
  const editorBase = isManagement ? "/management" : "/supervisor";
  const editorHref =
    isEditorAllowed && editorCrmId && editorProductId
      ? `${editorBase}/script-templates/edit?kind=client_card&crm=${editorCrmId}&product_id=${editorProductId}`
      : null;

  useEffect(() => {
    if (!crmId || !resolvedProductId) return;
    let isActive = true;

    const loadTemplate = async () => {
      setResolveLoading(true);
      
      try {
        const response = await fetchWithAuth(
          `${API_URL}/scripts/script-templates/resolve/?kind=client_card&crm=${crmId}&product_id=${resolvedProductId}`
        );
        if (!response.ok) {
          throw new Error("Помилка запиту");
        }
        const json = await response.json();
        if (isActive) {
          const payload = json?.data?.result ?? json?.data ?? json ?? {};
          const resolved =
            payload?.version ||
            payload?.data?.version ||
            payload?.result?.version ||
            json?.version ||
            null;
          setResolvedVersion(resolved || null);
          const crossFromTemplate =
            payload?.cross_products ||
            payload?.template?.cross_products ||
            payload?.version?.cross_products ||
            json?.cross_products ||
            json?.template?.cross_products ||
            json?.version?.cross_products;
          const nextCrossProducts = normalizeCrossProducts(crossFromTemplate);
          setResolvedCrossProducts(nextCrossProducts);
          const metaSource =
            payload?.cross_products_meta ||
            payload?.template?.cross_products_meta ||
            payload?.version?.cross_products_meta ||
            json?.cross_products_meta ||
            json?.template?.cross_products_meta ||
            json?.version?.cross_products_meta;
          const nextMeta = normalizeCrossMeta(metaSource);
          setCrossMeta(nextMeta);

          const templateId = Number(
            payload?.template?.id ?? payload?.template_id ?? resolved?.template
          );
          if (
            Number.isFinite(templateId) &&
            (!nextCrossProducts.length || !Object.keys(nextMeta).length)
          ) {
            try {
              const crossResponse = await fetchWithAuth(
                `${API_URL}/scripts/script-templates/${templateId}/cross-products/`
              );
              if (crossResponse.ok) {
                const crossJson = await crossResponse.json();
                if (isActive) {
                  const fallbackCrossProducts = normalizeCrossProducts(crossJson);
                  if (!nextCrossProducts.length) {
                    setResolvedCrossProducts(fallbackCrossProducts);
                  }
                  if (!Object.keys(nextMeta).length) {
                    setCrossMeta(normalizeCrossMeta(crossJson));
                  }
                }
              }
            } catch (err) {
              if (isActive) {
                console.error(err);
              }
            }
          }
        }
      } catch (err) {
        if (isActive) {
          console.error(err);
        }
      } finally {
        if (isActive) setResolveLoading(false);
      }
    };

    loadTemplate();

    return () => {
      isActive = false;
    };
  }, [crmId, resolvedProductId]);

  useEffect(() => {
    if (!crmId || !queryProductId) return;

    let isActive = true;

    const loadProductByCrm = async () => {
      setCrmProductLoading(true);
      setCrmProductError(null);
      try {
        const response = await fetchWithAuth(
          `${API_URL}/scripts/products/by-crm/${crmId}/`
        );
        if (!response.ok) throw new Error("Помилка запиту продуктів CRM");
        const list = await response.json();
        const map = {};
        if (Array.isArray(list)) {
          list.forEach((item) => {
            if (!item || item.product_id == null) return;
            map[String(item.product_id)] = item;
          });
        }
        if (isActive) {
          setCrmProductsMap(map);
        }
        const matched = Array.isArray(list)
          ? list.find(
              (item) => String(item.product_id) === String(queryProductId)
            )
          : null;
        if (isActive && matched) {
          setProductData(matched);
        }
      } catch (err) {
        if (isActive) setCrmProductError(err);
      } finally {
        if (isActive) setCrmProductLoading(false);
      }
    };

    loadProductByCrm();

    return () => {
      isActive = false;
    };
  }, [crmId, queryProductId]);

  useEffect(() => {
    setSelectedColor(productData?.colors?.[0] || null);
  }, [productData]);

  const product = productData || data;
  if (!product && (productLoading || crmProductLoading)) return null;
  if (!product) return null;

  const dropdowns = Array.isArray(product.dropdowns) ? product.dropdowns : [];
  const explicitObjections = Array.isArray(product.objections)
    ? product.objections
    : Array.isArray(product.faq)
    ? product.faq
    : null;
  const objectionPatterns = [/запереч/i, /питання/i, /faq/i, /вопрос/i];
  const isObjection = (title) =>
    objectionPatterns.some((pattern) => pattern.test(title || ""));

  const objectionItems = explicitObjections
    ? explicitObjections
        .map((item) => ({
          title: item.title || item.question || "Запитання",
          description: item.description || item.answer || "",
        }))
        .filter((item) => item.description || item.title)
    : dropdowns
        .filter((item) => isObjection(item.title))
        .map((item) => ({
          title: item.title,
          description: item.description || "",
        }));

  const scriptItems = explicitObjections
    ? dropdowns
    : dropdowns.filter((item) => !isObjection(item.title));

  const templateCrossProducts = normalizeCrossProducts(resolvedCrossProducts);
  const productCrossProducts = normalizeCrossProducts(product.cross_products);
  const crossProducts = mergeCrossProducts([
    templateCrossProducts,
    productCrossProducts,
  ]);
  const crossProductsForView = crossProducts.map((item) => {
    const crmProductId = item?.product_id;
    const metaKey =
      crmProductId != null ? String(crmProductId) : null;
    const metaValue = metaKey ? crossMeta[metaKey] ?? "" : "";
    const lookup =
      crmProductId != null ? crmProductsMap[String(crmProductId)] : null;
    if (!lookup) {
      return {
        ...item,
        short_description: metaValue || item?.short_description || "",
      };
    }
    const merged = { ...lookup, ...item };
    return {
      ...merged,
      image: merged.image || lookup.image,
      title: merged.title || lookup.title,
      short_description:
        metaValue ||
        merged.short_description ||
        lookup.short_description ||
        "",
      script_product_id:
        merged.script_product_id ?? lookup.id ?? merged.id ?? null,
      crm: merged.crm ?? lookup.crm ?? crmId,
    };
  });
  const templateSections = Array.isArray(resolvedVersion?.sections)
    ? resolvedVersion.sections
    : [];
  const buildSectionsByItemFilter = (sections, filterFn) => {
    const sortedSections = sections
      .map((section) => {
        const items = Array.isArray(section.items)
          ? section.items
              .filter(filterFn)
              .slice()
              .sort(
                (a, b) =>
                  Number(a.order ?? 0) - Number(b.order ?? 0)
              )
          : [];
        if (!items.length) return null;
        return { ...section, items };
      })
      .filter(Boolean);

    return sortedSections
      .slice()
      .sort(
        (a, b) =>
          Number(a.order ?? 0) - Number(b.order ?? 0)
      );
  };

  const normalizeItemType = (item) =>
    String(item?.item_type || "").toLowerCase();
  const faqSections = buildSectionsByItemFilter(templateSections, (item) =>
    ["faq", "note"].includes(normalizeItemType(item))
  );
  const mainScriptSections = buildSectionsByItemFilter(
    templateSections,
    (item) => normalizeItemType(item) === "script"
  );
  const objectionSections = buildSectionsByItemFilter(
    templateSections,
    (item) => normalizeItemType(item) === "objection"
  );

  return (
    <Layout>
      <Card
        sx={{
          boxShadow: "none",
          borderRadius: 2,
          width: "100%",
          maxWidth: "none",
        }}
      >
        <Grid
          container
          spacing={3}
          sx={{
            width: "100%",
            px: { xs: 2, sm: 3, md: 4 },
            pr: { xs: 2, sm: 3, md: 0 },
            py: { xs: 2, sm: 3, md: 4 },
            mx: 0,
          }}
        >
          {/* Левый блок: картинка и кнопка */}
          <Grid item xs={12} md={5}>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
              height="100%"
            >
              {/* Картинка продукта */}
              <ProductImg image={product.image} alt={product.title} />

              {/* Кнопка и количество выбранного цвета */}
              {selectedColor && (
                <Box display="flex" alignItems="center" gap={2} mt={2}>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#6C63FF",
                      textTransform: "none",
                      borderRadius: "8px",
                      px: 3,
                    }}
                    style={{ color: "white" }}
                  >
                    Списати
                  </Button>

                  <Typography variant="body1">
                    Кількість: <strong>{selectedColor.quantity}</strong>
                  </Typography>
                </Box>
              )}
            </Box>
          </Grid>

          {/* Средний блок: данные товара */}
          <Grid item xs={12} md={4}>
            <Box display="flex" flexDirection="column" gap={2} height="100%">
              <Box display="flex" alignItems="flex-start">
                <Typography variant="h6">{product.title}</Typography>
              </Box>

              {/* Характеристики */}
              <Stack direction="row" spacing={1} flexWrap="wrap">
                {product.attributes.map((block) =>
                  block.values.map((val) => (
                    <Typography key={val.id} sx={chipStyle}>
                      {block.name}: {val.value}
                    </Typography>
                  ))
                )}
                {!product.attributes.length && (
                  <Typography variant="body2" color="text.secondary">
                    Немає атрибутів
                  </Typography>
                )}
              </Stack>

              {/* Цвета */}
              <Stack
                direction="row"
                spacing={1}
                flexWrap="wrap"
                alignItems="center"
              >
                <Color
                  selectedColor={selectedColor}
                  setSelectedColor={setSelectedColor}
                  colors={product?.colors}
                />
              </Stack>
            </Box>
          </Grid>

          {/* Правый блок: FAQ/додаткова інфа */}
          <Grid
            item
            xs={12}
            md={3}
            sx={{
              alignSelf: { md: "flex-start" },
              ml: { md: "auto" },
              pr: { md: 1.5 },
              maxWidth: { md: 360 },
              width: "100%",
            }}
          >
            <Box
              sx={{
                border: "1px solid rgba(0,0,0,0.08)",
                borderRadius: 2,
                p: 2,
                width: "100%",
              }}
            >
              {resolveLoading ? (
                <Typography>Завантаження...</Typography>
              ) : resolvedVersion && faqSections.length ? (
                <ScriptTemplateViewer sections={faqSections} variant="side" />
              ) : (
                <Typography color="text.secondary">Немає даних</Typography>
              )}
            </Box>
          </Grid>
        </Grid>
      </Card>
      <Box sx={{ mt: 3 }}>
        {crossProductsForView.length > 0 ? (
          <>
            <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
              Крос товари
            </Typography>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                overflowX: "auto",
                pb: 1,
                scrollSnapType: "x mandatory",
                border: "1px solid rgba(0,0,0,0.08)",
                borderRadius: 2,
                p: 2,
              }}
            >
              {crossProductsForView.map((product, index) => {
                const crmProductId = product.product_id;
                const crossCrmId = product.crm ?? crmId;
                const routeId =
                  product.script_product_id ?? product.id ?? crmProductId;
                const crossLink =
                  routeId && crossCrmId && crmProductId
                    ? `/operator/scripts/${routeId}?crm=${crossCrmId}&product_id=${crmProductId}`
                    : null;
                const priceLabel = formatPrice(product.price);
                return (
                <Card
                  key={product.cross_id || product.id || crmProductId || index}
                  variant="outlined"
                  onClick={() => handleCrossOpen(product)}
                  sx={{
                    minWidth: 220,
                    maxWidth: 260,
                    flex: "0 0 auto",
                    scrollSnapAlign: "start",
                    position: "relative",
                    cursor: "pointer",
                  }}
                >
                  <CardContent
                    sx={{
                      display: "flex",
                      gap: 1.5,
                      color: "text.primary",
                      ".dark-theme &": { color: "rgba(255,255,255,0.92)" },
                    }}
                  >
                    <Box
                      sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                        gap: 0.5,
                      }}
                    >
                      <Box
                        sx={{
                          px: 1,
                          py: 0.25,
                          borderRadius: 999,
                          fontSize: "0.7rem",
                          backgroundColor: "rgba(0,0,0,0.04)",
                          color: "text.secondary",
                          ".dark-theme &": {
                            backgroundColor: "rgba(255,255,255,0.12)",
                            color: "rgba(255,255,255,0.75)",
                          },
                        }}
                      >
                        ID: {crmProductId ?? "—"}
                      </Box>
                    </Box>
                    <Avatar
                      src={product.image}
                      alt={product.title}
                      variant="rounded"
                      sx={{ width: 48, height: 48 }}
                    />
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <Typography
                        variant="subtitle2"
                        noWrap
                        sx={{ ".dark-theme &": { color: "rgba(255,255,255,0.92)" } }}
                      >
                        {product.title || "Без назви"}
                      </Typography>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        noWrap
                        sx={{ ".dark-theme &": { color: "rgba(255,255,255,0.72)" } }}
                      >
                        {product.short_description || ""}
                      </Typography>
                      <Box
                        sx={{
                          mt: 0.5,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: 1,
                        }}
                      >
                        {crossLink ? (
                          <Button
                            size="small"
                            sx={{ px: 0, minWidth: "auto" }}
                            onClick={(event) => {
                              event.stopPropagation();
                              handleCrossOpen(product);
                            }}
                          >
                            Відкрити
                          </Button>
                        ) : (
                          <Typography variant="caption" color="text.secondary">
                            Немає посилання
                          </Typography>
                        )}
                        {priceLabel ? (
                          <Box
                            sx={{
                              display: "inline-flex",
                              alignItems: "center",
                              px: 0.75,
                              py: 0.25,
                              borderRadius: 999,
                              fontSize: "0.75rem",
                              fontWeight: 600,
                              backgroundColor: "rgba(16,185,129,0.12)",
                              color: "rgba(16,185,129,0.9)",
                              ".dark-theme &": {
                                backgroundColor: "rgba(16,185,129,0.22)",
                                color: "rgba(167,243,208,1)",
                              },
                            }}
                          >
                            {priceLabel} грн
                          </Box>
                        ) : (
                          <span />
                        )}
                      </Box>
                      </Box>
                    </CardContent>
                  </Card>
                );
              })}
            </Box>
          </>
        ) : (
          <Typography variant="body2" color="text.secondary">
            Немає крос товарів
          </Typography>
        )}
      </Box>
      <Dialog
        open={Boolean(selectedCrossProduct)}
        onClose={handleCrossClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Крос товар</DialogTitle>
        <DialogContent dividers>
          {selectedCrossProduct ? (
            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
              <Avatar
                src={selectedCrossProduct.image}
                alt={selectedCrossProduct.title}
                variant="rounded"
                sx={{ width: 140, height: 140 }}
              />
              <Box sx={{ flex: 1, minWidth: 220 }}>
                <Typography variant="subtitle1" sx={{ mb: 0.5 }}>
                  {selectedCrossProduct.title || "Без назви"}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 1,
                    alignItems: "center",
                    mb: 1,
                  }}
                >
                  <Box
                    sx={{
                      px: 1,
                      py: 0.25,
                      borderRadius: 999,
                      fontSize: "0.75rem",
                      backgroundColor: "rgba(0,0,0,0.04)",
                      color: "text.secondary",
                      ".dark-theme &": {
                        backgroundColor: "rgba(255,255,255,0.12)",
                        color: "rgba(255,255,255,0.75)",
                      },
                    }}
                  >
                    ID: {selectedCrossProduct.product_id ?? "—"}
                  </Box>
                  {formatPrice(selectedCrossProduct.price) ? (
                    <Box
                      sx={{
                        px: 1,
                        py: 0.25,
                        borderRadius: 999,
                        fontSize: "0.75rem",
                        fontWeight: 600,
                        backgroundColor: "rgba(16,185,129,0.12)",
                        color: "rgba(16,185,129,0.9)",
                        ".dark-theme &": {
                          backgroundColor: "rgba(16,185,129,0.22)",
                          color: "rgba(167,243,208,1)",
                        },
                      }}
                    >
                      {formatPrice(selectedCrossProduct.price)} грн
                    </Box>
                  ) : null}
                </Box>
                <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
                  {selectedCrossProduct.short_description || "Опис відсутній"}
                </Typography>
              </Box>
            </Box>
          ) : null}
        </DialogContent>
        <DialogActions>
          {selectedCrossProduct?.product_id &&
          selectedCrossProduct?.crm &&
          (selectedCrossProduct.script_product_id ||
            selectedCrossProduct.id) ? (
            <Button
              component={Link}
              to={`/operator/scripts/${
                selectedCrossProduct.script_product_id ??
                selectedCrossProduct.id ??
                selectedCrossProduct.product_id
              }?crm=${selectedCrossProduct.crm}&product_id=${
                selectedCrossProduct.product_id
              }`}
            >
              Відкрити
            </Button>
          ) : null}
          <Button onClick={handleCrossClose}>Закрити</Button>
        </DialogActions>
      </Dialog>

      <Box sx={{ mt: 3 }}>
        <Tabs value={scriptTab} onChange={handleScriptTabChange}>
          <Tab label="Скрипт" />
          <Tab label="Характеристики" />
        </Tabs>
        <Box sx={{ mt: 2 }}>
          {scriptTab === 0 ? (
            resolveLoading ? (
              <Typography color="text.secondary">Завантаження...</Typography>
            ) : resolvedVersion &&
              (mainScriptSections.length || objectionSections.length) ? (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                {mainScriptSections.length ? (
                  <Box>
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      sx={{ mb: 1 }}
                    >
                      Скрипт
                    </Typography>
                    <ScriptTemplateViewer sections={mainScriptSections} />
                  </Box>
                ) : null}

                {objectionSections.length ? (
                  <Box>
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      sx={{ mb: 1 }}
                    >
                      Заперечення
                    </Typography>
                    <ScriptTemplateViewer sections={objectionSections} />
                  </Box>
                ) : null}
              </Box>
            ) : !resolvedVersion && scriptItems.length > 0 ? (
              scriptItems.map((item) => (
                <MuiAccordion
                  className="rmui-card"
                  key={item.id}
                  expanded={expanded === item.id}
                  onChange={handleChange(item.id)}
                  sx={{ my: 1 }}
                >
                  <MuiAccordionSummary
                    expandIcon={
                      <ArrowForwardIosSharpIcon sx={{ fontSize: "0.8rem" }} />
                    }
                    aria-controls={`${item.id}-content`}
                    id={`${item.id}-header`}
                  >
                    <Typography fontWeight={600}>{item.title}</Typography>
                  </MuiAccordionSummary>
                  <MuiAccordionDetails>
                    <Typography sx={{ whiteSpace: "pre-line" }}>
                      {item.description}
                    </Typography>
                  </MuiAccordionDetails>
                </MuiAccordion>
              ))
            ) : (
              <Typography color="text.secondary">Немає скрипта</Typography>
            )
          ) : product.characteristics ? (
            <MuiAccordion className="rmui-card" defaultExpanded sx={{ my: 1 }}>
              <MuiAccordionSummary
                expandIcon={
                  <ArrowForwardIosSharpIcon sx={{ fontSize: "0.8rem" }} />
                }
              >
                <Typography fontWeight={600}>Опис</Typography>
              </MuiAccordionSummary>
              <MuiAccordionDetails>
                <Typography sx={{ whiteSpace: "pre-line" }}>
                  {product.characteristics}
                </Typography>
              </MuiAccordionDetails>
            </MuiAccordion>
          ) : (
            <Typography color="text.secondary">
              Немає характеристик
            </Typography>
          )}
        </Box>
      </Box>

      {isEditorAllowed && editorHref && (
        <Box
          sx={{
            mt: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          <Typography variant="subtitle1" fontWeight={600}>
            Шаблон скрипта
          </Typography>
          <Button
            variant="outlined"
            component="a"
            href={editorHref}
            sx={{ textTransform: "none" }}
          >
            Редагувати шаблон
          </Button>
        </Box>
      )}

    </Layout>
  );
};

const chipStyle = {
  border: "1px solid rgba(255,255,255,0.1)",
  borderRadius: "12px",
  px: 2,
  py: 1,
  display: "flex",
  alignItems: "center",
  gap: "10px",
  width: "fit-content",
  fontSize: "14px",
};

export default ProductDetailsContent;
